export const PAYMENTS_POST_UNDERWRITING_ACCESS = 'commerce-payments-access';
export const SUBSCRIPTIONS_ACCESS = 'subscriptions-access';
export const INVOICES_READ = 'invoices-read';
export const PARTNER_CLIENT_READ = 'partner-client-object-read';
export const PARTNER_ACCOUNT_READ = 'partner-account-object-read';
export const PARTNER_SERVICE_READ = 'partner-service-object-read';
export const PARTNER_ACCOUNT_OBJECT_ACCESS = 'partner-account-object-access';